import { render, staticRenderFns } from "./BasicFilter.vue?vue&type=template&id=6952f4a9"
import script from "./BasicFilter.vue?vue&type=script&lang=js"
export * from "./BasicFilter.vue?vue&type=script&lang=js"
import style0 from "./BasicFilter.vue?vue&type=style&index=0&id=6952f4a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BasicFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports